export const GET_CLASSES_FULL_DATA_REQUEST = 'GET_CLASSES_FULL_DATA_REQUEST'
export const GET_CLASSES_FULL_DATA_SUCCESS = 'GET_CLASSES_FULL_DATA_SUCCESS'
export const GET_CLASSES_FULL_DATA_FAILURE = 'GET_CLASSES_FULL_DATA_FAILURE'
